import { useSearchParams } from "react-router-dom";
import { StaffTeamPageForm } from "./StaffTeamPageForm";

export function TeamPageNew() {
  const [params] = useSearchParams();
  // Pre-populate company when navigated from FirmDetail's "create team page" CTA.
  const initialCompanyId = params.get("companyId") ?? undefined;
  return <StaffTeamPageForm mode="create" initialCompanyId={initialCompanyId} />;
}

export default TeamPageNew;
